import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { TID } from "@/lib/testIds";

export default function Login() {
  const { therapistLogin } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [err, setErr] = React.useState("");
  const [busy, setBusy] = React.useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await therapistLogin(email, password);
      const to = loc.state?.from?.pathname || "/therapist";
      nav(to, { replace: true });
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="sw-card p-8">
        <h1 className="display text-3xl font-bold">Therapist sign-in</h1>
        <p className="text-[var(--sw-ink-soft)] mt-1">For clinicians managing student rosters.</p>
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <label className="block">
            <span className="text-sm font-semibold">Email</span>
            <input data-testid={TID.loginEmail} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full h-12 px-4 rounded-xl border border-[var(--sw-line)] bg-white" />
          </label>
          <label className="block">
            <span className="text-sm font-semibold">Password</span>
            <input data-testid={TID.loginPassword} type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full h-12 px-4 rounded-xl border border-[var(--sw-line)] bg-white" />
          </label>
          {err && <div data-testid={TID.loginError} className="text-sm text-[var(--gusty-text)] bg-[var(--gusty-bg)] border border-[var(--gusty-border)] rounded-xl p-3">{err}</div>}
          <button data-testid={TID.loginSubmit} disabled={busy} className="sw-pill w-full h-12 justify-center bg-[var(--sw-primary)] text-white border-[var(--sw-primary)] text-base">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <div className="mt-6 text-sm text-[var(--sw-ink-soft)]">
          New here? <Link to="/register" className="text-[var(--sw-primary)] font-semibold underline">Create a therapist account</Link>
        </div>
        <div className="mt-3 text-sm text-[var(--sw-ink-soft)]">
          Student? <Link to="/student-login" className="text-[var(--sw-primary)] font-semibold underline">Use your username &amp; PIN</Link>
        </div>
        <div className="mt-6 p-3 rounded-xl bg-[var(--sw-bg-soft)] border border-[var(--sw-line)] text-xs text-[var(--sw-ink-soft)]">
          <div className="font-semibold text-[var(--sw-ink)]">Demo therapist</div>
          <div>therapist@sensewise.app · Therapist1234!</div>
        </div>
      </div>
    </div>
  );
}
